import { toast } from 'react-toastify';

/**
 * Show error toast notification
 * @param {string|object} error - Error message or error object
 * @param {string} defaultMessage - Default message if error parsing fails
 */
export const showErrorToast = (error, defaultMessage = 'An error occurred') => {
  let message = defaultMessage;

  if (typeof error === 'string') {
    message = error;
  } else if (error?.data) {
    // Backend error format: { detail: "message" } or { field: ["error1", "error2"] }
    if (error.data.detail) {
      message = error.data.detail;
    } else if (typeof error.data === 'string') {
      message = error.data;
    } else {
      // Handle field-specific errors
      const errorMessages = [];
      Object.keys(error.data).forEach((key) => {
        const fieldErrors = Array.isArray(error.data[key])
          ? error.data[key]
          : [error.data[key]];
        errorMessages.push(...fieldErrors);
      });
      message = errorMessages.join('. ') || defaultMessage;
    }
  } else if (error?.message) {
    message = error.message;
  }

  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

/**
 * Show success toast notification
 * @param {string} message - Success message
 */
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

/**
 * Show info toast notification
 * @param {string} message - Info message
 */
export const showInfoToast = (message) => {
  toast.info(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

/**
 * Show warning toast notification
 * @param {string} message - Warning message
 */
export const showWarningToast = (message) => {
  toast.warning(message, {
    position: 'top-right',
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};



